import { z } from "zod";

export const PV_RECEPTION_CLIENT_CIVILITIES = ["M", "Mme"] as const;
export type PvReceptionClientCivility =
  (typeof PV_RECEPTION_CLIENT_CIVILITIES)[number];

export const pvReceptionHeaderSchema = z
  .object({
    orderNumber: z.string(), // N° bon de commande
    orderDate: z.string(), // date bon de commande, ISO yyyy-mm-dd
    greenkubModel: z.string(), // ex. "GK 25 COMPLET PLUS"
    teamName: z.string(), // auto depuis le profil équipe
    teamLead: z.string(), // chef d'équipe, saisi
    clientCivility: z.enum(PV_RECEPTION_CLIENT_CIVILITIES),
    clientFirstName: z.string(),
    clientLastName: z.string(),
    address: z.string(),
  })
  .partial();

export type PvReceptionHeader = z.infer<typeof pvReceptionHeaderSchema>;
